/*
 * chv-lf-shared.js
 * Lógica común a las secciones Leather Fits / Denim.
 * Se carga una sola vez (guard __chvLfSharedInit) aunque varias secciones lo pidan.
 *
 *  1) Programación por fecha  → elementos con data-active-from / data-active-up-to
 *  2) Reveal on scroll        → elementos con clase .chv-leather-fits-reveal
 *  3) Poster fade-in          → elementos con [data-poster] dentro de .chv-slide__layer
 *
 * Compatible con el editor de temas (shopify:section:load).
 */
(function () {
  'use strict';
  if (window.__chvLfSharedInit) return;
  window.__chvLfSharedInit = true;

  /* ── 1) Programación por fecha ─────────────────────────────────
     El valor viene "quemado" desde el customizer via data-attribute.
     Se normaliza a ISO (espacio → "T") para que Safari lo parsee,
     y se valida isNaN para no ocultar por un valor inválido. */
  function parseDate(raw) {
    if (!raw) return null;
    var d = new Date(raw.trim().replace(' ', 'T'));
    return isNaN(d.getTime()) ? null : d;
  }

  function applySchedule(scope) {
    var els = (scope || document).querySelectorAll('[data-active-from], [data-active-up-to]');
    var now = Date.now();
    els.forEach(function (el) {
      var from = parseDate(el.getAttribute('data-active-from'));
      var to   = parseDate(el.getAttribute('data-active-up-to'));
      if (from && from.getTime() > now) { el.style.display = 'none'; return; }
      if (to   && to.getTime()   < now) { el.style.display = 'none'; }
    });
  }

  /* ── 2) Reveal on scroll ───────────────────────────────────────
     Un solo IntersectionObserver global. Mismos parámetros que tenían
     las 6 secciones (threshold 0.1, rootMargin -60px). */
  var revealObs = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('chv-lf-visible');
            revealObs.unobserve(e.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' })
    : null;

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.chv-leather-fits-reveal:not(.chv-lf-visible)');
    if (revealObs) {
      els.forEach(function (el) { revealObs.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('chv-lf-visible'); });
    }
  }

  /* ── 3) Poster fade-in ─────────────────────────────────────────
     Dismisses a [data-poster] fallback image once the real video/image
     inside its media layer has finished loading. Scoped to `scope` so a
     section reload in the editor only touches its own posters.
     Matches two layer conventions: chv-lf-hero's `.chv-slide__layer` /
     `.chv-slide__layer-img`, and the generic `.chv-media-layer` /
     `.chv-media-layer-img` reused by Fits Grid, DJ Washes and Atelier.

     Video readiness: "canplay" alone can fire before the first frame is
     actually composited on screen, leaving a brief blank gap between the
     poster fading out and the video visibly starting (reported on
     chv-lf-hero). "playing" confirms a real painted frame, so it's the
     primary signal; "canplay" is kept as a backward-compatible fallback
     with a short safety timeout, in case "playing" never fires (e.g.
     autoplay blocked by the browser) — the poster must never stay stuck. */
  function initPosterFade(scope) {
    var posters = (scope || document).querySelectorAll('[data-poster]:not(.chv-poster-loaded)');
    posters.forEach(function (poster) {
      var layer = poster.closest('.chv-slide__layer, .chv-media-layer');
      if (!layer) return;
      var video = layer.querySelector('video');
      var img = layer.querySelector('.chv-slide__layer-img, .chv-media-layer-img');
      var dismissed = false;
      function dismiss() {
        if (dismissed) return;
        dismissed = true;
        poster.classList.add('chv-poster-loaded');
      }
      if (video) {
        if (!video.paused && video.readyState >= 3) { dismiss(); return; }
        video.addEventListener('playing', dismiss, { once: true });
        video.addEventListener('canplay', function () {
          setTimeout(dismiss, 400);
        }, { once: true });
      } else if (img) {
        if (img.complete) { dismiss(); return; }
        img.addEventListener('load', dismiss, { once: true });
      } else {
        setTimeout(dismiss, 200);
      }
    });
  }

  function run(scope) {
    applySchedule(scope);
    initReveal(scope);
    initPosterFade(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); });
  } else {
    run(document);
  }

  /* Editor de temas: re-ejecuta solo sobre la sección recargada. */
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
}());
